define('AwaLabs.ItemSegmentation', [
    'Profile.Model',
    'SC.Configuration',
    'ItemSegmentation.Utils',
    'underscore',
    'ItemSegmentation.Item.Model',
    'ItemSegmentation.Products.Base.View'
], function ItemSegmentation(
    ProfileModel,
    Configuration,
    ItemSegmentationUtils,
    _
) {
    'use strict';

    return {
        mountToApp: function mountToApp() {
            var collectionsToExtended;
            var profile = ProfileModel.getInstance();
            var customerCategory = profile.get('isLoggedIn') === 'T' ? _.findWhere(profile.get('customfields'), { name: 'custentity6' }) : '';

            Configuration.searchApiMasterOptions = ItemSegmentationUtils.addToSearchAPIMasterOptions(
                Configuration.searchApiMasterOptions,
                customerCategory
            );

            collectionsToExtended = [
                'ItemRelations.Related.Collection',
                'ItemRelations.Correlated.Collection',
                'RecentlyViewedItems.Collection' // This generates a second request on search
            ];

            _.each(collectionsToExtended, function eachCollectionToEnhance(collection) {
                ItemSegmentationUtils.extendCollection(collection, customerCategory);
            });
        }
    };
});
